export default {
  title: 'Płatność',
  description: 'Wszystkie transakcje są bezpieczne i szyfrowane',
  show_more_payment_methods: 'Pokaż więcej metod płatności',
  express_checkout_divider: 'lub',
};
